// src/components/bex-api-context/bex-api-context.tsx
import React from "react";
var defaults = {
  context: {}
};
var BexApiContext = React.createContext(defaults);
var BexApiProvider = ({
  children,
  context
}) => {
  const value = React.useMemo(() => ({
    context
  }), [context]);
  return /* @__PURE__ */React.createElement(BexApiContext.Provider, {
    value
  }, children);
};
BexApiProvider.displayName = "BexApiProvider";
var useBexApi = () => React.useContext(BexApiContext);
export { BexApiProvider, useBexApi };
//# sourceMappingURL=index.js.map